import { app } from '../../../app';
import { Controller } from './sharing-center.controller';

app.component('companySharingCenter', {
    bindings: {
        publicServicesWithSso$: '<',
        publicServicesWithSsoAnd2FA$: '<',
        labels$: '<'
    },
    templateUrl: require('./sharing-center.html'),
    controller: Controller,
});



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/sharing-center.component.js